<template lang="pug">
	.custom-select-dropdown
		.current-value(ref="currentValue" v-pseudo-modal-show="'custom-select-' + this.name")
			i.fa.left-icon(v-if="options && options.icon" :class="options.icon")
			span {{values.find(value => value.value === vModel).title}}
			i.fa.fa-caret-down(v-if="options && options.addCaret")
		.available-values(v-pseudo-modal="'custom-select-' + this.name" ref="availableValues")
			span(v-for="value in values" @click="customSelectClick(value)") {{value.title}}
</template>

<script>

import Screen from "@/mixins/screen";
import {Server} from "@/services/Server";

export default {
	name: 'CustomSelect',
	mixins: [Screen],
	screen: {
		updateOn: [],
		events: {}
	},
	props: ["name", "values", "action", "vModel", "options"],
	data() {

		return {
			showed: true
		}
	},
	created() {
	},
	mounted() {

	},
	methods: {
		collectData() {
		},
		customSelectClick(value) {
			this.action(value.value);
			this.$refs.availableValues.style.display = 'none';
		}
	}
}

</script>

<style lang="sass">

	.custom-select-dropdown
		color: white
		align-self: center
		width: 120px

		>.current-value
			cursor: pointer

			>i.fa.left-icon
				padding-right: 10px
			>i.fa-caret-down
				padding-left: 10px

		>.available-values
			display: flex
			flex-direction: column
			position: absolute
			background-color: #3a3b4a
			border: 1px solid black
			border-radius: 15px
			padding-top: 5px
			padding-bottom: 5px
			transform: translateY(10px)

			>span
				margin-top:	5px
				margin-bottom: 5px
				padding: 5px 30px 5px 15px
				cursor: pointer

				&:hover
					background-color: #5c5985
</style>
